import script from "./LoginEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginEmail.vue?vue&type=script&setup=true&lang=ts"

import "./LoginEmail.vue?vue&type=style&index=0&id=855515b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-855515b4"]])

export default __exports__